var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Lib from "@core/libs";
var TCTabs = /** @class */ (function (_super) {
    __extends(TCTabs, _super);
    function TCTabs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TCTabs.prototype.onMounted = function () {
        this.initTabsLogic();
        this.findCurrentTab();
    };
    TCTabs.prototype.findCurrentTab = function () {
        var currentTab = this.el.querySelector('.tab-content.is-active');
        if (currentTab) {
            this.activateTab("#".concat(currentTab.id));
        }
    };
    TCTabs.prototype.initTabsLogic = function () {
        var _this = this;
        this.el.querySelectorAll('.tabs a').forEach(function (link) {
            link.addEventListener('click', function (event) {
                event.preventDefault();
                _this.activateTab(link.hash);
                link.parentElement.classList.add('is-active');
            });
        });
    };
    TCTabs.prototype.activateTab = function (id) {
        var newTab = this.el.querySelector(id);
        if (newTab) {
            if (this.currentTab) {
                this.currentTab.classList.remove('is-active');
                var currentTabLink = this.el.querySelector('.tabs .is-active');
                if (currentTabLink) {
                    currentTabLink.classList.remove('is-active');
                }
            }
            this.currentTab = newTab;
            this.currentTab.classList.add('is-active');
        }
    };
    return TCTabs;
}(Lib));
export default TCTabs;
